import { Outlet } from "react-router-dom";

export default function RightPanel(){
    return(
       <Outlet/>
    )
}